// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/CircularXXWeb-Book.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/CircularXXWeb-Medium.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* In your CSS file (e.g., styles.css) */
@font-face {
  font-family: 'CircularXXWeb-Book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'CircularXXWeb-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'CircularXXWeb-Book', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;EACjC,4DAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,4DAAqE;EACrE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["*{\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* In your CSS file (e.g., styles.css) */\n@font-face {\n  font-family: 'CircularXXWeb-Book';\n  src: url('./assets/fonts/CircularXXWeb-Book.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'CircularXXWeb-Medium';\n  src: url('./assets/fonts/CircularXXWeb-Medium.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody {\n  font-family: 'CircularXXWeb-Book', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
